// extracted by mini-css-extract-plugin
export default {"component":"task-edit_component__bmiG4","form":"task-edit_form__kqTZA","checkbox":"task-edit_checkbox__HW9zp","buttons":"task-edit_buttons__tOVpb"};